import { render, staticRenderFns } from "./modal_pedidos_abertos.vue?vue&type=template&id=d00c6a58&scoped=true&"
import script from "./modal_pedidos_abertos.vue?vue&type=script&lang=js&"
export * from "./modal_pedidos_abertos.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/modal.css?vue&type=style&index=0&id=d00c6a58&scoped=true&lang=css&"
import style1 from "./modal_pedidos_abertos.vue?vue&type=style&index=1&id=d00c6a58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00c6a58",
  null
  
)

export default component.exports